import React from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <Box minH="60vh" display="flex" alignItems="center" justifyContent="center" p={6}>
      <VStack spacing={4}>
        <Heading size="lg" color="red.500">403 - Akses ditolak</Heading>
        <Text>Anda tidak memiliki izin untuk mengakses halaman ini.</Text>
        <Button onClick={() => navigate("/")} colorScheme="green">Kembali ke Dashboard</Button>
      </VStack>
    </Box>
  );
};

export default ForbiddenPage;
